import { render, staticRenderFns } from "./SubclinicalStep.vue?vue&type=template&id=67145a74&scoped=true"
import script from "./SubclinicalStep.vue?vue&type=script&lang=js"
export * from "./SubclinicalStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67145a74",
  null
  
)

export default component.exports